module.exports = __webpack_public_path__ + "img/water-flash-line.bee7db65.svg";